import api from '../../../api/index';

export default {
  registerPartner({ rootGetters }, values) {
    return api.post('partner', values, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  get({ rootGetters, commit }, partnerId) {
    return api
      .get(`admin/partner/${partnerId}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setPartner', response.data.data);
      });
  },
  getContact({ rootGetters }, partnerId) {
    return api.get(`user/contact/${partnerId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getName({}, inviteCode) {
    return api.get(`partner/name/${inviteCode}`);
  },
  getAll({ rootGetters, commit }) {
    return api.get('admin/partner', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAllExternal({ rootGetters, commit }) {
    return api.get('admin/external-partner', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateData({ rootGetters }, data) {
    return api.put('admin/partner/update', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  indicateProfessional({ rootGetters }, data) {
    return api.post('partner/indicate/professional', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  notActive({ rootGetters }, id) {
    return api.get(`/partner/notactive/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  submitEmail({ rootGetters }, id) {
    return api.get(`/partner/submitemail/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  submitWhatsApp({ rootGetters }, dados) {
    return api.post('/partner/submitwhatsapp', dados, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  submitWhatsAppMessage({ rootGetters }, dados) {
    return api.post('/partner/submitwhatsappmessage', dados, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  registerShopkeeper({ rootGetters }, data) {
    return api.post('/partner/shopkeeper', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  report({ rootGetters }, filters) {
    return api.post('partner/report', filters, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getReportShopkeepers({ rootGetters }, filters) {
    return api.post('partner/report/shopkeepers', filters, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateTelephones({ rootGetters }, filters) {
    return api.put('user/telephone', filters, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateAddress({ rootGetters }, addressData) {
    return api.put('user/address', addressData, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDashboardData({ rootGetters }, data) {
    return api.post('partner/dashboard', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getInviteId({ rootGetters }, id) {
    return api.get(`partner/invite/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  validateInviteId({ rootGetters }, inviteId) {
    return api.get(`partner/validate/invite/${inviteId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  ranking({ rootGetters }, range) {
    return api.get(
      `partner/ranking?from=${range ? range.from : ''}&to=${
        range ? range.to : ''
      }`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  rankingExterno({ rootGetters }, range) {
    return api.get(
      `partner/external-ranking?from=${range ? range.from : ''}&to=${
        range ? range.to : ''
      }`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getShopkeepersPerLink({ rootGetters }, range) {
    return api.get(`partner/shopkeepers-link`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
